<script setup lang="ts">
import { ref} from 'vue'
  import {cn, toast} from '@/utils/utils'
  import { Input } from "@/components/ui/input";
  import { Button } from "@/components/ui/button";
  import SigninService from "@/services/signin/signin.service";
  import router from "@/router";
  import PasswordInput from "@/components/ui_custom/input/PasswordInput.vue";
  import { Separator } from '@/components/ui/separator'
  import {FormControl, FormField, FormItem, FormMessage} from "@/components/ui/form";
  import {toTypedSchema} from "@vee-validate/zod";
  import * as z from "zod";
  import {useForm} from "vee-validate";

  const isLoading = ref(false)
  const formSchema = toTypedSchema(z.object({
    email: z.string().email(),
    password: z.string(),
  }))
  const { handleSubmit } = useForm({
    validationSchema: formSchema,
  })

  const onSubmit = handleSubmit(async (values) => {
    const loggedUser = await SigninService.signIn(values.email, values.password);
    if (loggedUser?.data.statusCode === 200) {
      localStorage.setItem('user', JSON.stringify(loggedUser.data.data));
      await router.push({name: 'dashboard'});
      isLoading.value = false;
    } else {
      toast.error(loggedUser?.data.message);
    }
    isLoading.value = false;

    setTimeout(() => {
      isLoading.value = false
    }, 3000)
  })
</script>

<template>
  <div :class="cn('grid gap-6')">
    <form @submit="onSubmit">
      <div class="grid gap-2">
        <div class="grid gap-1">
          <FormField v-slot="{ componentField }" name="email">
            <FormItem class="w-full">
              <FormControl>
                <Input type="email" :placeholder="$t('column.email')" v-bind="componentField" auto-correct="off" />
              </FormControl>
              <FormMessage />
            </FormItem>
          </FormField>
          <FormField v-slot="{ componentField }" name="password">
            <FormItem class="w-full">
              <FormControl>
                <PasswordInput :placeholder="$t('column.password')" v-bind="componentField" auto-correct="off" />
              </FormControl>
              <FormMessage />
            </FormItem>
          </FormField>
        </div>
        <Button type="submit" :disabled="isLoading">
          {{ $t('login.login') }}
        </Button>
      </div>
    </form>
    <Separator class="my-1" />
    <RouterLink :to="{name: 'forgot'}" class="text-center text-sm">
      {{ $t('login.lost_password') }}
    </RouterLink>
  </div>
</template>

<style scoped>

</style>
